export default __webpack_public_path__ + "static/media/introRight.c26ba8dc.svg";